import React, { ReactNode } from "react";
import s from "./ParagraphSkeletonRow.module.scss";

type ParagraphSkeletonRowProps = {
  isLoading: boolean;
  children: ReactNode;
};

export const ParagraphSkeletonRow: React.FC<ParagraphSkeletonRowProps> = ({
  isLoading,
  children,
}) => {
  return (
    <>
      {isLoading ? (
        <div className={s.skeleton}>
          <div className="skeleton" />
        </div>
      ) : (
        children
      )}
    </>
  );
};
